<template>
  <div class="combobox-sale-item-display">
    <ComboboxSaleItemInfo :item="item" :unit-price="unitPrice" />
  </div>
</template>

<script setup lang="ts">
import ComboboxSaleItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxSaleItemInfo.vue"
import type { SaleItem } from "@/models/sale-item.model"
import { computed, inject } from "vue"
import type { Instruction } from "@/models/instruction.model"
import type { Ref } from "vue"
import usePriceAgreements from "@/composables/administration/price-agreements"

const props = defineProps<{
  item: SaleItem
}>()

const instruction = inject<Ref<Instruction> | undefined>("instruction", undefined)

const { unitPrice } = usePriceAgreements(
  computed(() => instruction?.value.project),
  props.item
)
</script>

<style scoped></style>
